import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useState} from "react";
import {ExclamationIcon, XIcon} from '@heroicons/react/outline'
import FieldCheckbox from "../../components/field-checkbox";

export default function ModalUserConfirm(props) {

    const {onClose, onConfirm, visible, title, text, btnColor, iconColor} = props;

    const [UpdateSubscription, setUpdateSubscription] = useState(false);

    const getBtnColors = () => {
        switch (btnColor) {
            case "blue":
                return " focus:ring-blue-500 bg-blue-600 hover:bg-blue-700";
                break;
            default:
                return " focus:ring-red-500 bg-red-600 hover:bg-red-700";
        }
    }

    const getIconColors = () => {
        switch (iconColor) {
            case "blue":
                return " text-blue-600";
                break;
            default:
                return " text-red-600";
        }
    }

    const getIconBGColors = () => {
        switch (iconColor) {
            case "blue":
                return " bg-blue-100";
                break;
            default:
                return " bg-red-100";
        }
    }

    return (
        <Transition show={visible} as={Fragment}>
            <Dialog as="div" static className="fixed z-20 inset-0 overflow-y-auto" open={visible} onClose={onClose}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 transition-opacity"/>
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                      </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                                <button
                                    type="button"
                                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                                    onClick={() => onClose(false)}
                                >
                                    <span className="sr-only">Close</span>
                                    <XIcon className="h-6 w-6" aria-hidden="true"/>
                                </button>
                            </div>
                            <div className="sm:flex sm:items-start">
                                <div
                                    className={"mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10" + (getIconBGColors())}>
                                    <ExclamationIcon className={"h-6 w-6" + (getIconColors())} aria-hidden="true"/>
                                </div>
                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                        {title}
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            {text}

                                            <p className="mt-3 text-sm text-gray-500">
                                                <span>Remove user subscription as well. This will lower total amount of user seats available. </span>
                                            </p>

                                            <div
                                                className={"sm:border-t sm:border-secondary-200 sm:pt-5"}>
                                                <div className="inline-block mr-1">
                                                    <FieldCheckbox onChange={(name, value) => {
                                                        setUpdateSubscription(value)
                                                    }}
                                                                   value={UpdateSubscription} />
                                                </div>
                                                <label
                                                       className="inline-block text-sm font-medium text-secondary-700">
                                                    Yes, remove
                                                </label>

                                            </div>

                                            {props.children}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    className={"w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" + (getBtnColors())}
                                    onClick={() => onConfirm(UpdateSubscription)}
                                >
                                    Confirm
                                </button>
                                <button
                                    type="button"
                                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:w-auto sm:text-sm"
                                    onClick={() => onClose(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}
